import React from 'react';
import styled from 'styled-components';
import {BodyContainer} from "../Container/Container";
import fresh from '../../assets/img/freshIcon.jpg';
import frozen from '../../assets/img/frozenIcon.jpg';

const StyledBodyContainer = BodyContainer.extend`
  display: flex;
  justify-content: left;
`;

const LegendContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.p`
  font-family: Cabin-Bold, sans-serif;
  font-size: 18px;
  color: #000;
`;

const GroupContainer = styled.div`
  display: flex;
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 12px;
  margin-right: 20px;

  img {
    margin-right: 10px;
  }
`;

const IconLegend = () => {
    return (
      <StyledBodyContainer>
          <LegendContainer>
              <Title>Icon Legend</Title>
              <GroupContainer>
                  <IconContainer>
                      <img src={fresh} alt="fresh icon"/>
                      <Title>Fresh</Title>
                  </IconContainer>
                  <IconContainer>
                      <img src={frozen} alt="frozen icon"/>
                      <Title>Frozen</Title>
                  </IconContainer>
              </GroupContainer>

          </LegendContainer>
      </StyledBodyContainer>
    );
};

export default IconLegend;



// WEBPACK FOOTER //
// ./src/components/ProductInfo/IconLegend.js